export enum AlertState {
  Checking = 'checking',
  NoGroup = 'noGroup',
  InvalidGroup = 'invalidGroup',
  ValidGroup = 'validGroup',
  MissingGroup = 'missingGroup',
}
